/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StorageProvider } from '../../../services/storage.provider';
import { AuthProvider } from '../../../services/auth.provider';
import { Multitenant } from '../../../services/multitenant.provider';
import { ArticlesService } from 'src/app/services/articles.service';

@Component({
  selector: 'app-bottom-menu',
  templateUrl: 'bottom-menu.html',
  styleUrls: ['bottom-menu.scss']
})
export class BottomMenuComponent implements OnInit {
  @Input() isActive: string;
  @Input() public isFilter: string;
  @Output() bottomNotify: EventEmitter<string> = new EventEmitter();
  public platformType: number;
  public general = false;
  public theme: any;
  public themeClass: string;
  public thematicfilessubcatPage: string;
  private uniq: number;

  constructor(
    public auth: AuthProvider,
    public multiTenant: Multitenant,
    private storage: StorageProvider,
    private route: Router,
    private service: ArticlesService
  ) { }

  ngOnInit() {
    this.getPlatformType();
    this.themeClass = this.multiTenant.getDomainClass();
    const min = 0;
    const max = 9999999999;
    this.uniq = this.getUniqueId(min, max);
    if (!localStorage.getItem('ID')) {
      localStorage.setItem('ID', this.uniq.toString());
    }

    if (this.isAuthenticated) {
      const newspaper = this.auth.hasAccessToMain();
      if (newspaper) {
        const newspaperarray = this.auth.hasAccessToMain().split(',');
        if (newspaperarray.length === 1) {
          this.service.getThematicFilesCategories(newspaper).subscribe((response) => {
            if (response[0].name === 'Général') {
              this.general = true;
              this.theme = response[0];
              this.thematicfilessubcatPage = 'ThematicfilessubcatPage';
            }
          });
        }
      }
    }
  }

  setThematicFilesPage() {
    if (this.auth.isAuthenticated() && this.auth.oneMainNewspaper()) {
      return 'ThematicfilescatPage';
    } else {
      return 'ThematicfilesPage';
    }
  }

  isAuthenticated() {
    return this.auth.isAuthenticated();
  }

  getPlatformType() {
    const platform = this.multiTenant.getDomainClass();

    if (
      platform === 'mquo' ||
      platform === 'actu' ||
      platform === 'aeco' ||
      platform === 'lepq' ||
      platform === 'playbacpresse'
    ) {
      this.platformType = 0;
    } else if (
      platform === 'week' ||
      platform === 'mlwk' ||
      platform === 'mwne' ||
      platform === 'mlne' ||
      platform === 'sema' ||
      platform === 'woch'
    ) {
      this.platformType = 1;
    } else if (platform === 'mquovideo' || platform === 'actuvideo') {
      this.platformType = 2;
    } else if (platform === 'clfy') {
      this.platformType = 4;
    } else {
      this.platformType = 3;
    }

    if (
      this.isFilter === 'mquo' ||
      this.isFilter === 'actu' ||
      this.isFilter === 'aeco' ||
      this.isFilter === 'lepq'
    ) {
      this.platformType = 0;
    }
    if (
      this.isFilter === 'week' ||
      this.isFilter === 'mlwk' ||
      this.isFilter === 'mwne' ||
      this.isFilter === 'mlne' ||
      this.isFilter === 'sema' ||
      this.isFilter === 'woch'
    ) {
      this.platformType = 1;
    }
    if (this.isFilter === 'mquovideo' || this.isFilter === 'actuvideo') {
      this.platformType = 2;
    }
  }

  goToThematicFiles(page) {
    if (page === 'ThematicfilesPage') {
      this.route.navigate(['dossiers-actualite']);
    }

    if (page === 'ThematicfilescatPage' || page === 'ThematicfilessubcatPage') {
      this.route.navigate(['dossiers-actualite', this.themeClass, this.theme.slug]);
    }
  }

  goHome() {
    this.route.navigate(['']);
  }

  goToArchives() {
    if (this.auth.isAuthenticated()) {
      if (this.multiTenant.getDomainClass() === 'mwjp') {
        this.route.navigate(['pdf'], { queryParams: { newspaper: 'mwjp' }});
      } else if (this.multiTenant.getDomainClass() === 'mwde') {
        this.route.navigate(['pdf'], { queryParams: { newspaper: 'mwde' }});
      } else if (this.multiTenant.getDomainClass() === 'clfy') {
        this.route.navigate(['pdf'], { queryParams: { newspaper: 'clfy' }});
      } else if (this.multiTenant.getDomainClass() === 'mljp') {
        this.route.navigate(['pdf'], { queryParams: { newspaper: 'mljp' }});
      } else if (this.multiTenant.getDomainClass() === 'mlde') {
        this.route.navigate(['pdf'], { queryParams: { newspaper: 'mlde' }});
      } else {
        this.route.navigate(['pdf', 'choisir-un-titre']);
      }
    } else {
      this.route.navigate(['connexion']);
    }
  }

  goToExposes() {
    this.route.navigate(['exposes']);
  }

  goToMenu() {
    this.route.navigate(['menu']);
  }

  goToEdit() {
    if (!this.auth.isAuthenticated()) {
      this.route.navigate(['connexion']);
    } else {
      const profile_id = this.storage.getStorage('logged_profile_id');
      const profile_nickname = this.storage.getStorage('logged_profile_nickname');
      const profile = {
        profile_id,
        profile_nickName: profile_nickname,
      };

      this.route.navigate(['editer-profil'], { queryParams: {  profile: JSON.stringify(profile) }});
    }
  }

  goToExternalArchives() {
    if (this.storage.getStorage('logged_profile_id')) {
      const profileId = this.storage.getStorage('logged_profile_id');
      window.open(
        'http://archives.playbacpresse.fr/?token=78372' + profileId + '93287',
        '_blank'
      );
    } else {
      this.route.navigate(['connexion']);
    }
  }

  goToFavorites() {
    this.route.navigate(['favoris']);
  }

  homeActive() {
    if (this.isActive === 'home') {
      return true;
    } else {
      return false;
    }
  }

  archivesActive() {
    if (this.isActive === 'archives') {
      return true;
    } else {
      return false;
    }
  }

  exposesActive() {
    if (this.isActive === 'exposes') {
      return true;
    } else {
      return false;
    }
  }

  concoursActive() {
    if (this.isActive === 'concours') {
      return true;
    } else {
      return false;
    }
  }

  dossiersActive() {
    if (this.isActive === 'dossiers') {
      return true;
    } else {
      return false;
    }
  }

  menuActive() {
    if (this.isActive === 'menu') {
      return true;
    } else {
      return false;
    }
  }

  getUniqueId(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  goStaticPage(slug) {
    if (this.auth.isAuthenticated()) {
      this.route.navigate(['page', slug]);
    } else {
      this.route.navigate(['connexion']);
    }
  }
}
